export const validateVariance = (endDate: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const todayNumber = new Date(today).getTime() / 1000;
  const _endDate = new Date(endDate);
  _endDate.setHours(23, 59, 59, 999);
  const endDateNumber = new Date(_endDate).getTime() / 1000;
  if (todayNumber <= endDateNumber) {
    return true;
  } else {
    return false;
  }
};
